import React, { useMemo, useCallback, useState } from "react";
import { Formik, Form, Field } from "formik";
import { useHistory } from "react-router-dom";
import * as Yup from "yup";
import AcceptenceModal from "./AcceptenceModal";
import toast from "react-hot-toast";
import axios from "axios";

const FormCreateUser = ({ data, page, setPage }) => {
  const [companyData, setData] = data;
  const history = useHistory();
  const [disabled, setDisabled] = useState(false);

  const validations = useMemo(
    () =>
      Yup.object().shape({
        user: Yup.string().required("No puede estar vacio"),
        password: Yup.string().required("No puede estar vacio"),
        confirmPassword: Yup.string()
          .required("No puede estar vacio")
          .min(8, "No puede tener menos de 8 caracteres")
          .oneOf([Yup.ref("password"), null], "Las contrasenas no coinciden"),
      }),
    []
  );

  const formSubmit = useCallback(
    async (values, { setSubmitting }) => {
      setSubmitting(true);
      setDisabled(true);

      const payloadJson = {
        ...companyData["basicInfo"],
        ...companyData["legalStatus"],
        ...companyData["contact"],
        ...companyData["extra"],
        ...values,
      };

      const payloadFormData = new FormData();

      Object.keys(payloadJson).forEach((key) => {
        payloadFormData.append(key, payloadJson[key]);
      });

      if (companyData["legalStatus"]?.companyRucImage == null) {
        payloadFormData.delete("companyRucImage");
      }

      try {
        const data = await axios.post("auth/create-company", payloadFormData);

        localStorage.clear();

        setTimeout(() => {
          toast.success("Usuario creado y en proceso de aprobación", {
            duration: 6000,
          });
        }, 900);
        history.push("/Login");
      } catch (error) {
        toast.error(`Error al crear usuario, ${error.response.data.message}`);
        setDisabled(false);
      } finally {
        setSubmitting(false);
        setDisabled(false);
      }
    },
    [setPage, page]
  );

  function mostrarPassword() {
    var cambio = document.getElementById("password");
    cambio.type === "password"
      ? (cambio.type = "text")
      : (cambio.type = "password");
  }

  return (
    <Formik
      initialValues={companyData["user"]}
      onSubmit={formSubmit}
      validationSchema={validations}
    >
      {({ errors, touched, isSubmitting }) => (
        <Form>
          <div className="form__companytitle text-center">
            Creación de Usuario
          </div>
          <div className="form__row row">
            <div className="col-sm-12 col-md-12">
              <label htmlFor="user">Usuario</label>
              <Field type="text" name="user" id="user"></Field>
              {errors.user && (
                <span className="form__validation form__validation--error">
                  {errors.user}
                </span>
              )}
            </div>
          </div>

          <div class="form__row row">
            <div className="col-sm-12 col-md-6">
              <label htmlFor="password">Contraseña</label>
              <Field type="password" name="password" id="password"></Field>
              <i
                class="fa fa-eye-slash password-icon"
                onClick={mostrarPassword}
              />
              {errors.password && (
                <span className="form__validation form__validation--error">
                  {errors.password}
                </span>
              )}
            </div>
            <div className="col-sm-12 col-md-6">
              <label htmlFor="confirmPassword">Confirmar Contraseña</label>
              <Field
                type="password"
                name="confirmPassword"
                id="confirmPassword"
              ></Field>
              {errors.confirmPassword && (
                <span className="form__validation form__validation--error">
                  {errors.confirmPassword}
                </span>
              )}
            </div>
          </div>

          <div className="form_row row">
            <div className="col-12">
              <Field
                type="checkbox"
                name="acceptence"
                id="acceptence"
                required
              />

              {errors.acceptence && (
                <span className="form__validation form__validation--error">
                  {errors.acceptence}
                </span>
              )}

              <div className="d-flex">
                <p>Aceptar términos y condiciones</p>
                <AcceptenceModal />
              </div>
            </div>
          </div>

          <div className="form_row row">
            <div className="col-sm-12 col-md-6">
              <button
                onClick={() => setPage(page - 1)}
                className="btn btn--gradient btn__icon btn__icon--door"
              >
                Atrás
              </button>
            </div>

            <div className="col-sm-12 col-md-6">
              <button
                type="submit"
                className="btn btn--gradient btn__icon btn__icon--door"
              >
                Enviar solicitud
              </button>
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default FormCreateUser;
